export enum SystemUsageRate {
  High = 'high',
  Medium = 'medium',
  Low = 'low',
  Unknown = 'unknown'
}